import React from 'react';
import {
  FormControlLabel,
  Switch,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Typography,
  FormGroup,
  TextField
} from '@material-ui/core';
import { regionForCountry } from '../../lib/findBobUtils';
import { get } from 'lodash';

const Details = ({ formData, handleCheckChange, handleMultiSelectChange, handleChange, company }) => {
  const partialSalesDetailedQuestions = company.feature_types.includes('partial_sales_detailed_questions');

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Details
      </Typography>
      <FormGroup>
        {formData.questions.map((question, index) => (
          <FormControlLabel
            key={index}
            control={
              <Switch
                checked={get(formData, `[answers][${index}]`, false)}
                onChange={handleCheckChange}
                name={index}
              />
            }
            label={question}
          />
        ))}
      </FormGroup>
      
      <FormControl fullWidth margin="normal">
        <InputLabel>{company.country === 'ca' ? "Provinces" : "States"}</InputLabel>
        <Select
          multiple
          value={formData.states || []}
          onChange={handleMultiSelectChange}
          renderValue={(selected) => selected.join(', ')}
        >
          {regionForCountry(company.country).map((state) => (
            <MenuItem key={state} value={state}>
              {state}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {partialSalesDetailedQuestions && (
        <>
        <Box mt={2}>
          <Typography variant="body2" gutterBottom>
            Client Demographics:
          </Typography>
          <TextField
            name="clientDemographicsDetails"
            value={formData.clientDemographicsDetails || ''}
            placeholder="Briefly describe the client demographics, e.g., high-net-worth individuals, small businesses, etc."
            onChange={(e) => {
              if (e.target.value.length <= 250) {
                handleChange(e);
              }
            }}
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            helperText={`${(formData.clientDemographicsDetails || '').length}/250`}
          />
        </Box>
        <Box mt={2}>
          <Typography variant="body2" gutterBottom>
            Services Provided:
          </Typography>
          <TextField
            name="servicesProvidedDetails"
            value={formData.servicesProvidedDetails || ''}
            placeholder="List the services provided to these clients, e.g., wealth management, retirement planning, investment advisory, etc."
            onChange={(e) => {
              if (e.target.value.length <= 250) {
                handleChange(e);
              }
            }}
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            helperText={`${(formData.servicesProvidedDetails || '').length}/250`}
          />
        </Box>
        <Box mt={2}>
          <Typography variant="body2" gutterBottom>
            Other:
          </Typography>
          <TextField
            name="otherDetails"
            value={formData.otherDetails || ''}
            placeholder="e.g., These clients have been meticulously nurtured and serviced, and we are seeking a buyer who can continue to provide exceptional financial guidance and support."
            onChange={(e) => {
              if (e.target.value.length <= 250) {
                handleChange(e);
              }
            }}
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            helperText={`${(formData.otherDetails || '').length}/250`}
          />
        </Box>
       </>
      )}
    </Box>

  );
};

export default Details;